module.exports = __webpack_public_path__ + "img/c545826.webp";